// extracted by mini-css-extract-plugin
export var footnotes = "UserTable-module--footnotes--nCfK3";
export var hasFootnotes = "UserTable-module--has-footnotes--OZCJ3";
export var highlight = "UserTable-module--highlight--Ub4fa";
export var noBottomBorder = "UserTable-module--no-bottom-border--U8k4N";
export var offerRoomUserTable = "UserTable-module--offer-room-user-table--2+rrN";
export var primary = "#06004d";
export var secondary = "#4dafd7";